import { SharedWith } from "src/apps/AppFlow/pages";
import { Page } from "src/components/FlowLayout";
import { PageState } from "src/hooks/usePageState";
import { Applicant, Property } from "src/types/Applicant";
import {
  EmployerDetailsValue,
  EmploymentDetailsValue,
  GeneralIncomeDetailsValue,
} from "src/types/Application";

import { enums, formatters } from "@fraction/shared";

import { EmployerDetails, EmploymentDetails, GeneralIncomeDetails, IncomeSourceType } from "./pages";

const { INCOME_TYPE_MAP } = formatters.enums;

export interface IncomeSourcePagesArgs {
  applicant?: Applicant;
  otherApplicants?: Applicant[];
  applicationPropertyLocation?: Property;

  incomeSourceType: PageState<enums.IncomeType>;
  employerDetails: PageState<EmployerDetailsValue>;
  incomeDetails: PageState<GeneralIncomeDetailsValue | EmploymentDetailsValue>;
  owners: PageState<Applicant[]>;

  onComplete: () => void;
}

const IncomeSourcePages = ({
  otherApplicants,
  applicant,
  incomeSourceType,
  employerDetails,
  incomeDetails,
  owners,
  applicationPropertyLocation,
}: IncomeSourcePagesArgs): Page[] =>
  [
    {
      name: "incomeSourceType",
      component: <IncomeSourceType location={applicationPropertyLocation} {...incomeSourceType} />,
    },
    incomeSourceType?.value === enums.IncomeType.EMPLOYMENT_INCOME
      ? {
          name: "employerDetails",
          component: <EmployerDetails {...employerDetails} />,
        }
      : undefined,
    incomeSourceType?.value === enums.IncomeType.EMPLOYMENT_INCOME ||
    incomeSourceType?.value === enums.IncomeType.SELF_EMPLOYMENT_INCOME
      ? {
          name: "incomeDetails",
          component: <EmploymentDetails {...incomeDetails} />,
        }
      : {
          name: "incomeDetails",
          component: <GeneralIncomeDetails {...incomeDetails} />,
        },
    otherApplicants?.length &&
      applicant &&
      incomeSourceType?.value &&
      [enums.IncomeType.INVESTMENT_INCOME, enums.IncomeType.RENTAL_INCOME].includes(
        incomeSourceType.value
      ) && {
        name: "incomeSharedWith",
        component: (
          <SharedWith
            otherApplicants={otherApplicants || []}
            applicant={applicant}
            sharedItemName={
              incomeSourceType.value ? INCOME_TYPE_MAP[incomeSourceType.value].toLowerCase() : "asset"
            }
            {...owners}
          />
        ),
      },
  ].filter((p): p is Page => Boolean(p));
export default IncomeSourcePages;
